'use client';

import React from 'react';
import styled from '@benzinga/themetron';

interface Props {
  disableColors: boolean;
  percent: number | string;
}

export const PercentMeter: React.FC<Props> = ({ disableColors = true, percent = 0 }) => {
  return (
    <PercentMeterStyle>
      <Span $disableColors={disableColors} $percent={typeof percent === 'number' ? percent : parseInt(percent)} />
    </PercentMeterStyle>
  );
};

const PercentMeterStyle = styled.div`
  background: ${props => props.theme.colors.backgroundInactive};
  width: 100%;
`;

const Span = styled.span<{ $disableColors?: boolean; $percent: number }>`
  display: inline-block;
  height: 1em;
  vertical-align: bottom;
  background: ${props =>
    !props.$disableColors
      ? props.$percent < 50
        ? props.theme.colors.statistic.negative
        : props.theme.colors.statistic.positive
      : props.theme.colors.brand};
  width: ${props => props.$percent}%;
`;
